import React, { useEffect } from "react";
import { createContext, useState } from "react";
import useMe from "../hooks/api/useMe";
import useAuth from "../hooks/useAuth";

export const WrapperContext = createContext({});

export function WrapperProvider({ children }) {
  const { me, loadMe, reloadMe } = useMe();
  const [breadcrumb, setbreadcrumb] = useState();
  const { token } = useAuth();
  const permissions = !!me?.permissions ? JSON.parse(me?.permissions) : {};

  useEffect(() => {
    token && reloadMe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  return (
    <WrapperContext.Provider
      value={{
        token,
        config,
        me,
        breadcrumb,
        setbreadcrumb,
        reloadMe,
        loadMe,
        permissions,
      }}
    >
      {((!!token && !!me) || !token) && children}
    </WrapperContext.Provider>
  );
}
